import React from "react";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import { withRouter } from "react-router";

import NavBar from "../components/NavBar";
import "./Login.css";

class Index extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}

  render() {
    return (
      <div className="background">
        <NavBar />
        <Container maxWidth="md" style={{ marginTop: "0px" }}>
          <Typography
            variant="h5"
            gutterBottom
            className="loginTitle"
            style={{ textAlign: "center" }}
          >
            Privacy Policy
          </Typography>

          <div className="terms-content">
            <div className="paragraph">
              <p>
                This Privacy Policy governs the manner in which envision.ai
                collects, uses, maintains and discloses information collected
                from users (each, a "User") of the http://www.envision.ai
                website ("Site").
              </p>
              <p>
                <b>PERSONAL IDENTIFICATION INFORMATION</b>
              </p>
              <p>
                We may collect personal identification information from Users in
                a variety of ways, including, but not limited to, when Users
                visit our site, register on the site, fill out a form, respond
                to a survey, and in connection with other activities, services,
                features or resources we make available on our Site. Users may
                be asked for, as appropriate, name, email address. Users may,
                however, visit our Site anonymously. We will collect personal
                identification information from Users only if they voluntarily
                submit such information to us. Users can always refuse to supply
                personally identification information, except that it may
                prevent them from engaging in certain Site related activities.
              </p>
              <p>
                <b>NON-PERSONAL IDENTIFICATION INFORMATION</b>
              </p>
              <p>
                We may collect non-personal identification information about
                Users whenever they interact with our Site. Nonpersonal
                identification information may include the browser name, the
                type of computer and technical information about Users means of
                connection to our Site, such as the operating system and the
                Internet service providers utilized and other similar
                information.
              </p>
              <p>
                <b>WEB BROWSER COOKIES</b>
              </p>
              <p>
                Our Site may use "cookies" to enhance User experience. User's
                web browser places cookies on their hard drive for
                record-keeping purposes and sometimes to track information about
                them. User may choose to set their web browser to refuse
                cookies, or to alert you when cookies are being sent. If they do
                so, note that some parts of the Site may not function properly.
              </p>
              <p>
                <b>HOW WE USE COLLECTED INFORMATION</b>
              </p>
              <p>
                envision.ai may collect and use Users personal information for
                the following purposes:
                <br />
                <span>• To run and operate our Site</span>
                <br />
                <span className="list-level-1">
                  We may need your information display content on the Site
                  correctly.
                </span>
                <br />
                <span>• To improve customer service</span>
                <br />
                <span className="list-level-1">
                  Information you provide helps us respond to your customer
                  service requests and support needs more efficiently.
                </span>
                <br />
                <span>• To personalize user experience</span>
                <br />
                <span className="list-level-1">
                  We may use information in the aggregate to understand how our
                  Users as a group use the services and resources provided on
                  our Site.
                </span>
                <br />
                <span>• To improve our Site</span>
                <br />
                <span className="list-level-1">
                  We may use feedback you provide to improve our products and
                  services.
                </span>
                <br />
                <span>
                  • To run a promotion, contest, survey or other Site feature
                </span>
                <br />
                <span>
                  • To send Users information they agreed to receive about
                  topics we think will be of interest to them.
                </span>
                <br />
                <span>• To send periodic emails</span>
                <br />
                <span className="list-level-1">
                  We may use the email address to send User information and
                  updates pertaining to their order. It may also be used to
                  respond to their inquiries, questions, and/or other requests.
                </span>
              </p>
              <p>
                <b>HOW WE PROTECT YOUR INFORMATION</b>
              </p>
              <p>
                We adopt appropriate data collection, storage and processing
                practices and security measures to protect against unauthorized
                access, alteration, disclosure or destruction of your personal
                information, username, password, transaction information and
                data stored on our Site.
              </p>
              <p>
                <b>SHARING YOUR PERSONAL INFORMATION</b>
              </p>
              <p>
                We do not sell, trade, or rent Users personal identification
                information to others. We may share generic aggregated
                demographic information not linked to any personal
                identification information regarding visitors and users with our
                business partners, trusted affiliates and advertisers for the
                purposes outlined above. We may use third party service
                providers to help us operate our business and the Site or
                administer activities on our behalf, such as sending out
                newsletters or surveys. We may share your information with these
                third parties for those limited purposes provided that you have
                given us your permission.
              </p>
              <p>
                <b>ELECTRONIC NEWSLETTERS</b>
              </p>
              <p>
                If User decides to opt-in to our mailing list, they will receive
                emails that may include company news, updates, related product
                or service information, etc. We may use third party service
                providers to help us operate our business and the Site or
                administer activities on our behalf, such as sending out
                newsletters or surveys. We may share your information with these
                third parties for those limited purposes provided that you have
                given us your permission.
              </p>
              <p>
                <b>THIRD PARTY WEBSITES</b>
              </p>
              <p>
                Users may find advertising or other content on our Site that
                link to the sites and services of our partners, suppliers,
                advertisers, sponsors, licensors and other third parties. We do
                not control the content or links that appear on these sites and
                are not responsible for the practices employed by websites
                linked to or from our Site. In addition, these sites or
                services, including their content and links, may be constantly
                changing. These sites and services may have their own privacy
                policies and customer service policies. Browsing and interaction
                on any other website, including websites which have a link to
                our Site, is subject to that website's own terms and policies.
              </p>
              <p>
                <b>COMPLIANCE WITH CHILDREN'S ONLINE PRIVACY PROTECTION ACT</b>
              </p>
              <p>
                Protecting the privacy of the very young is especially
                important. For that reason, we never collect or maintain
                information at our Site from those we actually know are under
                13, and no part of our website is structured to attract anyone
                under 13.
              </p>
              <p>
                <b>CHANGES TO THIS PRIVACY POLICY</b>
              </p>
              <p>
                envision.ai has the discretion to update this privacy policy at
                any time. When we do, we will post a notification on the main
                page of our Site. We encourage Users to frequently check this
                page for any changes to stay informed about how we are helping
                to protect the personal information we collect. You acknowledge
                and agree that it is your responsibility to review this privacy
                policy periodically and become aware of modifications.
              </p>
              <p>
                <b>YOUR ACCEPTANCE OF THESE TERMS</b>
              </p>
              <p>
                By using this Site, you signify your acceptance of this policy.
                If you do not agree to this policy, please do not use our Site.
                Your continued use of the Site following the posting of changes
                to this policy will be deemed your acceptance of those changes.
                This policy was generated using http://www.privacypolicies.com
              </p>
              <p>
                <b>CONTACTING US</b>
              </p>
              <p>
                If you have any questions about this Privacy Policy, the
                practices of this site, or your dealings with this site, please
                contact us.
              </p>
              <p>
                <i>This document was last updated on April 9, 2018</i>
              </p>
            </div>
          </div>
        </Container>
      </div>
    );
  }
}

export default withRouter(Index);
